var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main-content notfround"},[_c('h1',[_vm._v("404")]),_c('br'),_c('h4',{staticClass:"ml-3"},[_vm._v("Page Not Found")])])])
}]

export { render, staticRenderFns }